export default __webpack_public_path__ + "static/media/video_play.5e50f53f.svg";